export default __webpack_public_path__ + "locales/it/SingleSignOn.json?hash=efbe1efeaac756d152f31bec4b743b73";